import { SvgBase } from "../svg.base";

export const LeftArrow = () => (
  <SvgBase
    width="6"
    height="9"
    viewBox="0 0 6 9"
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M4.682 8.679L.942 5.494a1 1 0 0 1 0-1.523L4.683.786a.365.365 0 0 1 .515.514L2.835 4.086a1 1 0 0 0 0 1.293l2.362 2.786a.365.365 0 0 1-.515.514z"
    />
  </SvgBase>
);